import { render, staticRenderFns } from "./welfare_detail.vue?vue&type=template&id=01156a04&scoped=true&"
import script from "./welfare_detail.vue?vue&type=script&lang=js&"
export * from "./welfare_detail.vue?vue&type=script&lang=js&"
import style0 from "./welfare_detail.vue?vue&type=style&index=0&id=01156a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01156a04",
  null
  
)

export default component.exports